angular.module('impactx.search').component('ixLotList', {
        bindings: {
            lots: '<',
            trns: '<',
        },
        require: {
            containerCtrl: '^^ixListTabContainer'
        },
        controller: 'LotSearchListCtrl',
        controllerAs: 'lotSearchListCtrl',
        templateUrl: 'modules/search/templates/lot-list.html'
    }
);